<template>
    <div class="container">
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index < 3" class="img" :src="item">
            <div class="activityBox" v-if="activity.isShow && index == 0">
                <img class="activityImg" :src="activity.PCactiveImg">
            </div>
        </div>
        <div class="tab-section">
            <div class="main">
                <img class="tab-title-img" :src="tabMain.pctitleImg">
                <div class="_tb">
                    <el-tabs v-model="activeName" @tab-click="changeTab">
                        <el-tab-pane class="main-tab" v-for="(item, index) in (tabMain.stageList || [])" :key="index" :label="item.stage" :name="index">
                            <div class="region">
                                <div class="m-title"><div class="tx">{{item.title}}</div> <div class="btn" @click="showModalFn(item)"></div></div>
                                <div class="m-icon"></div>
                                <div class="m-txt">
                                    <div class="m-left">
                                        <div class="l-title">学习目标</div>
                                        <div class="bor"></div>
                                        <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" >{{v}}</div>
                                    </div>
                                    <div class="m-right">
                                        <div class="l-title">关键技术点</div>
                                        <div class="bor"></div>
                                        <div class="item" v-for="(v, i) in item.skillsList" :key="i" >{{v}}</div>
                                    </div>
                                </div>
                            </div>
                            
                        </el-tab-pane>
                    </el-tabs>
                    <button class="stage-more" @click="JumpFn">
                        <img :src="btnImg.stageMore">
                    </button>
                    <div class="tips-tab">
                        * 具体课程内容以实际课程安排和进度为准
                    </div>
                </div>

                <div class="modal" v-if="showModal">
                    <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                    <div v-for="(item, index) in showData.details" :key="index">
                        <div class="modal-title">
                            {{item.t}}
                        </div>
                        <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                            {{i}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index === 3 ||index === 4" class="img" :src="item">
        </div>
        <div class="tab-img-section">
            <div class="main">
                <div class="_tb">
                    <el-tabs v-model="activeImgName" @tab-click="changeTab">
                        <el-tab-pane class="main-tab" v-for="(item, index) in tabImgList" :key="index" :label="item.title" :name="index">
                            <div class="m-img">
                                <img :src="item.desc">
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <button class="btn-receive" @click="JumpFn">
                        <img :src="btnImg.receive">
                    </button>
                </div>
            </div>
        </div>
        <div class="tab-fill"></div>
        <div class="section" v-for="(item, index) in imgList" :key="index">
            <img v-if="index > 4" class="img" :src="item">
        </div>


        <button class="footer" @click="JumpFn">
            <img v-if="isBView === 'A'" :src="btnImg.footer">
            <img v-if="isBView === 'B'" :src="btnImg.footerB">
            <div class="iconBox" v-if="activity.isShow">
                <img class="icon" :src="activity.PCicon">
            </div>
        </button>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import activity from '../../../common/activity';


import List from './list'
export default {
    data() {
        return {
            activity,
            List,
            showModal:false,
            imgList:[],
            tabMain:{},
            tabImgList:[],
            btnImg:{},
            activeName:0,
            activeImgName:0,
            showData:{},
        }
    },
    props: ['isBView'],
    mounted () {
        setTimeout(()=>{
            this.eduPlatTrack('WebView', { page_id: '1s5m'});
        },500)
        let dataList = this.List.data.pc;

        this.imgList = dataList.imgList
        this.tabImgList = dataList.tabImgList
        this.btnImg = dataList.btnImg
        this.tabMain = this.List.data.tabMain
    },
    methods: {
        JumpFn() {
            this.eduPlatTrack('WebButtonClick', {
                'page_id': '1s5m',
                'button_name': this.isBView === 'B' ? '免费领取vip月卡' : '抢先领取试学名额'
            });
            // let key = this.isBView === 'B' ? '9abc23d41003464b8c76dcabbe6f7fdf' : '8e9e05fc691b4938ae6be0ed50422d1b';
            let key = '8e9e05fc691b4938ae6be0ed50422d1b';
            handleJumpUrl(key);
        },
        close() {
            this.showModal = false;
        },
        changeTab(val) {
            this.showModal = false
        },
        showModalFn(item) {
            this.showModal = true
            this.showData = item
        },
        
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background: #F1F3FF;
    padding-bottom: 150PX;
    .section {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        .img {
            width: 100%;
            display: block;
        }
        .activityBox {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%);
            width: 950PX;
            height: 150PX;
        }
        .activityImg {
            display: block;
            float: right;
            width: 104PX;
            height: 133PX;
        }
    }
    .tab-section {
        width: 100%;
        min-width: 1200PX;
        margin: 70PX 0 90PX;
        padding-top: 1PX;
        .main {
            position: relative;
            width: 1060PX;
            margin: 0 auto;
            padding-top: 1PX;
            .tips-tab {
                font-size: 14PX;
                color: #666;
                position: absolute;
                bottom: 80PX;
                right: 60PX;
            }
            .tab-title-img {
                position: absolute;
                top: 0;
                left: 0;
                display: block;
                width:100%;
            }
            ._tb {
                position: relative;
                margin: 95PX auto 0;
                width: 1000PX;
                background-color: #fff;
                box-sizing: border-box;
                padding: 30PX 40PX 100PX;
                border-radius: 22px;
                /deep/ .el-tabs {
                    width: 100%;
                    .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
                        height: 47PX;
                    }
                    .el-tabs__item {
                        line-height: 47PX;
                        text-align: center;
                        width: 150PX;
                        height: 47PX;
                        padding: 0;
                        font-size: 18PX;
                        font-family: SourceHanSansSC-Bold, SourceHanSansSC;
                        font-weight: 400;
                        color: rgba(50, 50, 50, 1);
                        margin: 0 17PX;
                    }
                    .el-tabs__nav-wrap::after{
                        background-color: transparent;
                    }
                    .el-tabs__active-bar {
                        background-color: transparent;
                    }
                    .el-tabs__item.is-active {
                        border-radius: 50PX;
                        padding: 0;
                        background: linear-gradient(327deg, #E33917 0%, #FF7500 100%);
                        color: #fff;
                    }
                }
                .region {
                    width: 100%;
                    padding-top: 20PX;
                    .m-title {
                        width: 100%;
                        height: 30PX;
                        position: relative;
                        font-size: 24PX;
                        color: #303032;
                        text-align: center;
                        font-family: Helvetica;
                        font-weight: normal;
                        .tx {
                            position: absolute;
                            top: 0PX;
                            left: 50%;
                            transform: translate(-50%);
                        }
                        .btn {
                            float: right;
                            width: 90PX;
                            height: 30PX;
                            background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                            background-size: 100% 100%;
                            margin-right: 40PX;
                        }
                    }
                    .m-icon {
                        margin: 8PX auto;
                        width: 688PX;
                        height: 2PX;
                        background: url('https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png') no-repeat center;
                        background-size: 100% 100%;
                    }
                    .m-txt {
                        width: 100%;
                        display: flex;
                        margin-top: 30PX;
                        .m-left {
                            flex: 1;
                            box-sizing: border-box;
                            padding: 10PX 30PX;
                        }
                        .m-right {
                            width: 312PX;
                            box-sizing: border-box;
                            padding: 10PX 10PX;
                        }
                        .l-title {
                            font-size: 16PX;
                            font-family: Helvetica;
                            color: #36363C;
                        }
                        .bor {
                            width: 312PX;
                            height: 1PX;
                            margin: 16PX 0 20PX;
                            background-color: rgba(132, 132, 135, .4);
                        }
                        .item {
                            position: relative;
                            font-size: 14PX;
                            font-family: Helvetica;
                            color: #49494B;
                            padding-left: 15PX;
                            margin: 14PX 0;
                            &::after {
                                position: absolute;
                                content: '';
                                left: 0PX;
                                top: 8PX;
                                width: 4PX;
                                height: 4PX;
                                border-radius: 50%;
                                background: #6469A7;
                            }
                        }
                    }
                }
            }
            .stage-more {
                position: absolute;
                bottom: -40PX;
                left: 50%;
                transform: translate(-50%);
                width: 448PX;
                background-color:transparent;
                border: none;
                z-index: 9;
                img {
                    width: 100%;
                    display: block;
                }
            }
            .modal {
                position: absolute;
                top: 260PX;
                left: 50%;
                transform: translate(-50%);
                width: 800PX;
                border-radius: 16PX;
                background-color: #fefefe;
                z-index: 999;
                border: 2PX solid #6469A7;
                box-sizing: border-box;
                padding: 20PX 50PX 40PX;
                .close {
                    position: absolute;
                    right: 14PX;
                    top: 14PX;
                    width: 40PX;
                    height: 40PX;
                }
                .modal-title {
                    font-size: 20PX;
                    padding:35PX 0 10PX;
                    color: #6469A7;
                }
                .modal-desc {
                    font-size: 14PX;
                    color: #6469A7;
                    padding-left: 18PX;
                }
            }
        }
        @media screen and (max-width:1600px){
            .main {
                width: 900PX;
                ._tb {
                    width: 860PX;
                    /deep/ .el-tabs {
                        .el-tabs__item {
                            margin: 0 3PX;
                        }
                    }
                }
            }
            
        }
        
    }
    .tab-img-section {
        width: 100%;
        min-width: 1200PX;
        margin: 40PX 0 0PX;
        padding-top: 1PX;
        .main {
            position: relative;
            width: 1060PX;
            margin: 0 auto;
            padding-top: 1PX;
            ._tb {
                position: relative;
                margin: 0PX auto 0;
                width: 1000PX;
                background-color: #fff;
                box-sizing: border-box;
                border-radius: 30PX;
                padding-bottom: 30PX;
                border-top-left-radius: 0PX;
                /deep/ .el-tabs {
                    width: 100%;
                    .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
                        height: 66PX;
                        background-color: rgba(26, 29, 60, 1);
                        border-top-right-radius: 30PX;
                    }
                    .el-tabs__item {
                        line-height: 66PX;
                        text-align: center;
                        width: 250PX;
                        height: 66PX;
                        padding: 0;
                        font-size: 24PX;
                        font-family: SourceHanSansSC-Bold, SourceHanSansSC;
                        font-weight: 400;
                        color: #fff;
                        background: url('https://s21.lgstatic.com/growth/activity/20210422/1619075679017.png') no-repeat center;
                        background-size: 100% 100%;
                        border-top-right-radius: 30PX;
                    }
                    .el-tabs__nav-wrap::after{
                        background-color: transparent;
                    }
                    .el-tabs__active-bar {
                        background-color: transparent;
                    }
                    .el-tabs__item.is-active {
                        padding: 0;
                        background: #fff;
                        color: #34397D;
                    }
                }
                .m-img {
                    width: 100%;
                    img {
                        display: block;
                        width: 100%;
                    }
                }
                .btn-receive {
                    position: absolute;
                    bottom: -50PX;
                    left: 50%;
                    transform: translate(-50%);
                    width: 448PX;
                    background-color:transparent;
                    border: none;
                    z-index: 9;
                    img {
                        width: 100%;
                        display: block;
                    }
                }
            }
        }
        @media screen and (max-width:1600px){
            .main {
                width: 900PX;
                ._tb {
                    width: 860PX;
                    /deep/ .el-tabs {
                        .el-tabs__item {
                            width: 215PX;
                        }
                    }
                }
            }
            
        }
    }
    .tab-fill {
        width: 100%;
        height: 250PX;
        background-color: rgba(33, 52, 110, 1);
        margin-top: -100PX;
    }
    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 999;
        width: 100%;
        img {
            width: 100%;
            display: block;
        }
        .iconBox {
            position: absolute;
            top: -30PX;
            left: 50%;
            transform: translate(-50%);
            z-index: 9999;
            width: 940PX;
            .icon {
                float: right;
                width: 134PX;
            }
        }
    }
}

</style>